<section [ngClass]="formatter">
  <header>
    <h3 *ngIf="field.label" [innerHTML]="field.label"
      class="bl-font-size--base bl-font-color-steel bl-font-weight--900 bl-margin--0"></h3>
    <p *ngIf="field.config.subLabel"
      class="bl-font-color--steel bl-font-color--black bl-font-size--14 bl-margin-bottom--0 bl-margin-top--4"
      [innerHTML]="field.config.subLabel"></p>
  </header>
  <ul class="bl-bulleted-list bl-padding-left--16 bl-margin-top--16">
    <li *ngFor="let item of field.enum">
      <p [innerHTML]="item.label" class="bl-margin--0"></p>
    </li>
  </ul>
</section>
